export class Range<D> {
    constructor(
        public min: D,
        public max: D,
    ) {}
}

export class DateRange {
    constructor(
        public start: string | null,
        public end: string | null,
    ) {}
}
